import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { Loader } from "@kuda/ui";

import SignIn from "../signinPage/signinPage";
import SecretList from "../Actions/SecretList";
import UserInfo from "../components/userInfo";
import CreateSecretForm from "../Actions/CreateSecretForm";
import UpdateSecretForm from "../Actions/UpdateSecretForm";
import ViewSecret from "../Actions/ViewSecret";
import AuthWrapper from "../auth/authWrapper";

function AuthGuard({ children }) {
  const { inProgress, instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  // Set active account if available
  if (!instance.getActiveAccount() && instance.getAllAccounts().length > 0) {
    instance.setActiveAccount(instance.getAllAccounts()[0]);
  }

  // Wait for MSAL to initialize completely
  const msalReady =
    inProgress === InteractionStatus.None &&
    (instance.getActiveAccount() || instance.getAllAccounts().length === 0);

  if (!msalReady) {
    return (
      <div className="flex items-center justify-center" style={{ height: "100vh" }}>
        <Loader type="brand" />
      </div>
    );
  }

  // Only render children when MSAL is ready
  return children(isAuthenticated);
}

export default function AppRoutes() {
  return (
    <AuthGuard>
      {(isAuthenticated) => (
        <Routes>
          {/* SignIn */}
          <Route
            path="/signin"
            element={isAuthenticated ? <Navigate to="/secrets" replace /> : <SignIn />}
          />

          {/* Root redirect */}
          <Route
            path="/"
            element={isAuthenticated ? <Navigate to="/secrets" replace /> : <Navigate to="/signin" replace />}
          />

          {/* Protected routes */}
          <Route path="/secrets" element={<AuthWrapper><SecretList /></AuthWrapper>} />
          <Route path="/user-info" element={<AuthWrapper><UserInfo /></AuthWrapper>} />
          <Route path="/create-secret" element={<AuthWrapper><CreateSecretForm /></AuthWrapper>} />
          {/* Splat (not :secretName) — Vault secret names can be nested paths (e.g. dev/kuda-internaltools/foo)
              containing literal slashes; a plain param only matches the first segment. */}
          <Route path="/update-secret/*" element={<AuthWrapper><UpdateSecretForm /></AuthWrapper>} />
          <Route path="/view-secret/*" element={<AuthWrapper><ViewSecret /></AuthWrapper>} />
        </Routes>
      )}
    </AuthGuard>
  );
}